import React from 'react';
import TeamBg from '../Components/TeamBg.js';
import Section404 from '../Components/Section404.js';
import TeamAbout from '../Components/TeamAbout.js';
import Art from '../Components/Art.js';
import './pages.css';
import './aboutus.css'
import bgmshops from '../images/bgteamsection.webp';

function AboutUs() {
    return (
        <>
         <section className='pagesIndex aboutus' style={{ backgroundImage: `url(${bgmshops})` }} name='bgmshops'>
                    <div className='content'>
                        <p className='subtitles'>ABOUT</p>
                        <h2><span>INDEX<div className='registered'>®</div><i>-</i></span></h2>
                        <div className='textoWorks'>
                            <h3>Meet <strong>Index®</strong></h3>
                            <p>Somos una agencia digital radicada en Argentina. Nuestra tripulación está conformada por un equipo de profesionales que combinan diseño, tecnología y creatividad para resolver las necesidades de comunicación online de cada empresa.</p>
                        </div>
                    </div>

        </section>
        <TeamAbout/>
        <Section404/>
        <TeamBg/>
        <Art/>
        </>
    )
}
export default AboutUs